module.exports = __webpack_public_path__ + "static/media/up-arrow.a294b826.svg";